import Grid from "@mui/material/Grid2";
import React from "react";
import { Skeleton } from "@mui/material";

export const SiteListSkeleton: React.FC = () => {
  return (
    <Grid container mt={2} spacing={2}>
      {Array(8)
        .fill(0)
        .map((_, index) => (
          <Grid key={index}>
            <Skeleton variant="rounded" width={220} height={188} />
          </Grid>
        ))}
    </Grid>
  );
};
